module.exports = ".label{border:dotted}\n"